var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container admin-wrapper"},[_c('b-row',[_c('b-col',{staticClass:"d-none d-lg-block",attrs:{"cols":"0","lg":"4"}},[_c('admin-dash-board-side-menu')],1),_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }